import { ClickOutsideDetector, IconArrowRight } from '@ui/src';
import { MoveDocumentsControlTypes } from '../types';

import cn from '../styles.module.css';

const MoveDocumentsControl = ({
  setMenuVisible,
  menuVisible,
  moveInProgress,
  selectedCategory,
  allDocumentsSelected,
  selectedDocumentsCountByCategory,
  allowedCategories,
  documentsByCategoryId,
  allDocuments,
  changeCustomerDocumentsCategoryAction,
}: MoveDocumentsControlTypes) => (
  <ClickOutsideDetector
    className={cn.selectedDocumentsMoveWrapper}
    setOptionsListVisible={setMenuVisible}
  >
    <>
      <button
        type="button"
        className={`${cn.selectedDocumentsButton} ${
          menuVisible ? cn.selectedDocumentsButtonActive : ''
        }`}
        onClick={() => setMenuVisible(!menuVisible)}
        disabled={moveInProgress}
      >
        <IconArrowRight
          className={cn.selectedDocumentsButtonIcon}
          width={10}
          height={10}
        />
        {moveInProgress ? 'Loading...' : 'Move to group'}
      </button>
      {menuVisible && (
        <ul className={cn.selectedDocumentsMenu}>
          <li className={cn.selectedDocumentsMenuTitle}>
            Which group to move &nbsp;
            {selectedCategory && selectedCategory?.id === 'all'
              ? allDocumentsSelected
              : selectedDocumentsCountByCategory}
            &nbsp; documents to?
          </li>
          {allowedCategories?.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={cn.selectedDocumentsMenuButton}
                onClick={() => {
                  const selectedIds: string[] = [];

                  allowedCategories?.forEach((allowedCategory) => {
                    if (
                      documentsByCategoryId &&
                      documentsByCategoryId[allowedCategory.id]
                    ) {
                      documentsByCategoryId[allowedCategory.id]?.forEach(
                        (category) => {
                          category.documents?.forEach((document) => {
                            if (document.isSelected) {
                              selectedIds.push(document.id);
                            }
                          });
                        },
                      );
                    }
                  });

                  if (allDocuments) {
                    allDocuments.all?.forEach((category) => {
                      category.documents?.forEach((document) => {
                        if (
                          document.isSelected &&
                          !selectedIds.find((id) => id === document.id)
                        ) {
                          selectedIds.push(document.id);
                        }
                      });
                    });
                  }

                  changeCustomerDocumentsCategoryAction(item.id, selectedIds);

                  setMenuVisible(false);
                }}
              >
                {item.name.includes('Add other document')
                  ? 'Other documents'
                  : item.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  </ClickOutsideDetector>
);

export default MoveDocumentsControl;
